export {
    default as TemplateAgreement,
    ITemplateAgreementProps,
} from './agreement';
